import { getInitialState } from '@/store/modules/lists/helper';

import mutations from './mutations';
import getters from './getters';

const initialState = getInitialState();

export default {
  namespaced: true,
  state: initialState,
  mutations,
  getters,
}
